import '@dweidner/ajax-fragment-element';

import { whenFound } from '@/utilities/component.js';
import { whenAccepted } from '@/utilities/consent.js';

import { Accordion } from '@/elements/Accordion/Accordion.js';
import { Disclosure } from '@/elements/Disclosure/Disclosure.js';

export default {
  /** @param {Object} _app */
  install(_app) {
    customElements.define('custom-accordion', Accordion);
    customElements.define('custom-disclosure', Disclosure);

    whenFound('custom-combobox', () => (
      import('@/elements/Combobox/Combobox.js')
        .then(({ Combobox }) => customElements.define('custom-combobox', Combobox))
        .catch(() => {
          console.warn(`Could not load <custom-combobox>`);
        })
    ));

    whenFound('custom-gallery', () => (
      import('@/elements/Gallery/Gallery.js')
        .then(({ Gallery }) => customElements.define('custom-gallery', Gallery))
        .catch(() => {
          console.warn(`Could not load <custom-gallery>`);
        })
    ));

    whenFound('custom-carousel', () => (
      Promise.all([
        import('@/elements/Carousel/Carousel.js'),
        import('@/elements/Carousel/CarouselItem.js')
      ])
        .then(([{ Carousel }, { CarouselItem }]) => {
          customElements.define('custom-carousel', Carousel);
          customElements.define('custom-carousel-item', CarouselItem);
        })
        .catch(() => {
          console.warn(`Could not load <custom-carousel>`);
        })
    ));

    whenAccepted('Google Maps', () => {
      whenFound('gmp-feature-layer', () => (
        import('@/elements/FeatureLayer/FeatureLayer.js')
          .then(({ FeatureLayer }) => customElements.define('gmp-feature-layer', FeatureLayer))
          .catch(() => {
            console.warn(`Could not load <gmp-feature-layer>`);
          })
      ));
    });
  }
};
